import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as actions from "../../store/actions/actions";
import {Button, Card, CardBody, Col, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText} from "reactstrap";
import "./password.css"
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";

import italianPasswordTranslations from "../../translations/password/password/it.password.password.json";
import englishPasswordTranslations from "../../translations/password/password/en.password.password.json";

class Password extends PureComponent {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianPasswordTranslations, "it");
    this.props.addTranslationForLanguage(englishPasswordTranslations, "en");
  }

  submitHandler = (event) => {
    event.preventDefault();
    let username=this.user(this.props.history);
    let email = event.target.email.value;
    let newPassword = event.target.newPassword.value;
    let newPasswordConfirmation = event.target.newPasswordConfirmation.value;
    const data = {username,email, newPassword, newPasswordConfirmation};
    this.props.change(data)
  }

  email = (path) => {
    let pathName = path.location.pathname
    if(pathName !== 'undefined' && pathName !== null) {
      let splitPathName = pathName.split("/")
      let decoded=atob(splitPathName[2])
      let email = decoded.split(":")
      return email[1]
    }
  }
  user = (path) => {
    let pathName = path.location.pathname
    if(pathName !== 'undefined' && pathName !== null) {
      let splitPathName = pathName.split("/")
      let decoded=atob(splitPathName[2])
      let user = decoded.split(":")
      return user[0]
    }
  }

  render() {

    let errors="";
    errors=this.props.validationError;
    let upperCaseError=false;
    let lowerCaseError=false;
    let notMatching=false;
    let specialCharError=false;
    let numberError=false;
    let lenght=false;
    let hasErrors=false;

    // if(errors !== null && errors !== ""){
    //   if(errors.status === 400){
    //     if(errors.data.validation !== null && errors.data.validation !==""){
    if(errors !== null && errors !== "" && errors !== undefined){
      if(errors.data.length>0){
        errors.data.map((item) =>{

          if(item.code === 'user.create.password.notMatch'){
            notMatching=true
            hasErrors=true
          }
          if(item.code === 'user.create.password.length'){
            lenght=true
            hasErrors=true
          }

          if(item.code === 'user.create.password.special'){
            specialCharError=true
            hasErrors=true
          }

          if(item.code === 'user.create.password.upper'){
            upperCaseError=true
            hasErrors=true
          }

          if(item.code === 'user.create.password.lower'){
            lowerCaseError=true
            hasErrors=true
          }

          if(item.code === 'user.create.password.number'){
            numberError=true
            hasErrors=true
          }
        })
      }
    }

    let bankFromUrl = this.props.history.location.pathname.split("/")[1];
    let bankDefault = 'plick'
    let bank = (bankFromUrl !== undefined || bankFromUrl !== '' || bankFromUrl !== null) ? bankFromUrl : bankDefault;
    localStorage.setItem('bank', bank);

    return (
        <>
          <Col lg="5" md="7" className="mt--9">
            <Card className="bg-secondary shadow border-0">
              <CardBody className="px-lg-5 py-lg-5">
                <div className="text-center text-muted mb-4">
                  <small>
                    <Translate id="password.title"/>
                  </small>
                </div>
                <div>
                  <small className={hasErrors === true ? "highlight":""}>
                    <Translate id="password.constraint"/>
                    </small>
                  <ul>
                    <li className={notMatching === true ? "highlight":"noErrors"}>
                      <Translate id="password.match.constraint"/>
                      </li>
                    <li>
                      <small className={lenght === true ? "highlight":""}>
                        <Translate id="password.eight.character.constraint"/>
                      </small>
                    </li>
                    <li>
                      <small className={upperCaseError === true ? "highlight":""}>
                        <Translate id="password.upper.case.character.constraint"/>
                        </small>
                    </li>
                    <li>
                      <small className={lowerCaseError === true ? "highlight":""}>
                        <Translate id="password.lower.case.character.constraint"/>
                        </small>
                    </li>
                    <li>
                      <small className={numberError === true ? "highlight":""}>
                        <Translate id="password.number.character.constraint"/>
                        </small>
                    </li>
                    <li>
                      <small className={specialCharError === true ? "highlight":""}>
                        <Translate id="password.special.character.constraint"/>
                        </small>
                    </li>
                  </ul>

                </div>
                <form onSubmit={this.submitHandler}>
                  <FormGroup className="mb-3">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-email-83" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Translate>
                        {({ translate }) =>
                          <Input id="email"
                                 disabled
                             placeholder={translate("password.email")}
                             value={this.email(this.props.history)}
                             type="text" />}
                      </Translate>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-lock-circle-open" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Translate>
                        {({ translate }) =>
                          <Input id="newPassword"
                             placeholder={translate("password.newPassword")}
                             type="password"
                             autoComplete="newPassword" />}
                      </Translate>
                    </InputGroup>
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <InputGroup className="input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-lock-circle-open" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Translate>
                        {({ translate }) =>
                          <Input id="newPasswordConfirmation"
                             placeholder={translate("password.newPassword.confirmation")}
                             type="password"
                             autoComplete="newPasswordConfirmation" />}
                      </Translate>
                    </InputGroup>
                  </FormGroup>
                  <div className="text-center">
                    <Button className="my-4" type="submit" text={`Save password`} variant="contained" color="primary">
                      <Translate id="password.update.button"/>
                    </Button>
                  </div>
                </form>
              </CardBody>
            </Card>
          </Col>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    validationError:state.password.error,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    change: (password) => dispatch({ type: actions.CHANGE_PASSWORD_REQUEST, value: password })
  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Password));
